/**
 * Registers the service worker, and only where it belongs.
 *
 * Production only: a worker in front of the dev server intercepts the module
 * graph Vite is hot-reloading, and the first symptom is an edit that does not
 * appear until a hard reload - which costs more time to diagnose than offline
 * support in dev could ever save.
 *
 * Deferred until `load` so the registration competes with nothing on the
 * critical path. The worker is what makes the site installable alongside the
 * manifest; nothing in the app reads from it, and a browser that refuses to
 * register one simply gets the site it already had.
 */

export const SERVICE_WORKER_URL = '/sw.js'

export const registerServiceWorker = (): void => {
  if (!import.meta.env.PROD) return
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SERVICE_WORKER_URL)
      .catch((cause: unknown) => console.error('pwa: could not register the service worker', cause))
  })
}
